<nav class="navbar navbar-light py-0 navbar-expand-md" [ngClass]="user() ? 'navbar-loggedin':'navbar-loggedout'">
  <div class="container-fluid">
    @let brandVariable = brand();
    <a class="navbar-brand" [ngClass]="{'light-mode':!darkModeActive()}" routerLink="/" [attr.aria-label]="'Home'">
      @if (!brandVariable?.logo_banner) {
        <multisite-website-logos [logo]="logo()"></multisite-website-logos>
      }
      @if (brandVariable?.logo_banner) {
        <img [src]="getLogoFile('logo_banner') | imageUrl" height="60px" width="auto" [alt]="brandVariable.name"
          class="logo-banner">
      }
      @if (brandVariable?.logo_square) {
        <img [src]="getLogoFile('logo_square') | imageUrl" height="60px" width="auto" [alt]="brandVariable.name"
          class="logo-square">
      }
    </a>
    <button class="navbar-toggler" type="button" (click)="navCollapsed = !navCollapsed" aria-controls="navbarNav"
      aria-expanded="false" aria-label="Toggle navigation">
      <i class="fas fa-bars"></i>
    </button>

    <div class="collapse navbar-collapse justify-content-end" id="navbarNav" [collapse]="navCollapsed"
      [isAnimated]="true">
      <ul class="navbar-nav" *transloco="let t">

        @for (link of navLinks(); track link) {
<li class="nav-item" [ngClass]="{'hide' : 
        (!user() && link.condition == 'hideIfNoUser') ||
        (!hasRole('Admin') && link.condition == 'hideIfNotAdmin') ||
        (!hasRole('Developer') && link.condition == 'hideIfNotDeveloper')
      }">
            <a class="nav-link" aria-current="page" [routerLink]="link.routerLinkValue"
            routerLinkActive="active">{{link.labelLanguageKey ? t(link.labelLanguageKey) : link.labelText}}</a>
          </li>
        }

        @if(user()){
          <!-- Dropdrown from sidenav -->
          <li class="nav-item d-md-none" >

            <div class="profile-details" dropdown>
              <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" dropdownToggle
                (click)="false" aria-expanded="false" aria-controls="navbarDropdown-dropdown">
                <div class="user-details">
                  <div class="d-flex align-items-center gap-2">
                    <img class="user-profile-img" [src]="user() | userAvatar" alt="Profile image">
                    <p class="name h5 text-wrap">{{user().fname+' '+user().lname}}</p>
                  </div>
                  <!-- ICON DROPDOWN -->
                  <span class="icon">
                    <i class="fa-solid fa-angle-down"></i>
                  </span>
                  <!-- END OF ICON DROPDOWN -->
                </div>
              </a>
              <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                aria-labelledby="button-animated">
                @for (link of filteredAccountDropdownLinks(); track link) {
                  <li [ngClass]="{'dropdown-header' : link.isHeader}">
                    @if (link.isHeader) {
                      <p>{{t(link.labelTranslationKey)}}</p>
                    }
                    @if (link.isDivider) {
                      <hr class="dropdown-divider">
                    }
                    @if (!link.isDivider && !link.isHeader) {
                      <a class="dropdown-item large" [routerLink]="link.routerLinkArray" routerLinkActive="active" (click)="link.clickHandler ? handleClick(link.clickHandler) : true">
                        <span class="icon-holder">
                          <i [class]="link.iconClasses"></i>
                        </span>
                        <div>
                          <p>{{t(link.labelTranslationKey)}}</p>
                        </div>
                      </a>
                    }
                  </li>
                }
              </ul>
            </div>
          </li>
        }

        <li class="nav-item align-items-center">
          <div class="splitter"></div>
        </li>

        <li class="nav-item languages dropdown">
          <span dropdown>
            @if (activeLanguageObject) {
              <a class="nav-link dropdown-toggle" id="navbarLanguageDropdown" role="button"
                dropdownToggle (click)="false" [attr.aria-label]="activeLanguageObject.flag_class" aria-expanded="false"
                aria-controls="navbarLanguageDropdown-dropdown">
                <img [src]="getFlagUrl(activeLanguageObject,'w_24,c_fill,ar_1:1,r_max/','.png')" [alt]="t(activeLanguageObject.name)" class="mr-1">
              </a>
            }
            <ul id="navbarLanguageDropdown-dropdown" *dropdownMenu class="dropdown-menu" role="menu"
              aria-labelledby="navbarLanguageDropdown">
              @for (availableLanguage of availableLanguages; track availableLanguage) {
                <li>
                  <a class="dropdown-item" (click)="setActiveLanguage(availableLanguage.languageKey)">
                    <img [src]="getFlagUrl(availableLanguage,'w_16,c_fill,ar_1:1,r_max/','.png')"
                      [alt]="t(availableLanguage.name)" class="mr-1">
                      {{t('languages.'+availableLanguage.languageKey)}}
                    </a>
                  </li>
                }
              </ul>
            </span>
          </li>
          @if(user()){
            <li class="nav-item">
              <div class="splitter"></div>
            </li>
            <li multisiteNotificationBell></li>
              <!-- <li class="nav-item">
              <div class="splitter"></div>
            </li> -->
            <!-- NOTIFICATIONS not implemented yet -->
            <!-- <li mdbDropdown class="nav-item dropdown dropstart" *ngIf="user()">
            <a class="nav-link dropdown-toggle" id="navbarNotificationsDropdown" role="button" mdbDropdownToggle
              aria-expanded="false">
              <i class="fa-solid fa-bell"></i>
            </a>
            <!-- <span class="nav-link-mobile pl-2">Notifications</span> // comment this line out

            <ul mdbDropdownMenu class="dropdown-menu dropdown-navbar-loggedin"
              aria-labelledby="navbarNotificationsDropdown">
              <li class="dropdown-header">
                <p>Notifications</p>
              </li>
              <li>
                <a class="dropdown-item text-info" href="#">
                  <i class="fa-solid fa-circle-info"></i>
                  <div>
                    <p class="notification-title text-wrap">Meditation</p>
                    <p class="notification-subtitle"><span class="pr-1">Richard Farkas</span>•<span class="pl-1">1 day
                  ago</span></p>
                </div>
              </a>
            </li>
            <li>
              <a class="dropdown-item text-danger" href="#">
                <i class="fa-solid fa-circle-info"></i>
                <div>
                  <p class="notification-title text-wrap">Your client requested a call</p>
                  <p class="notification-subtitle"><span class="pr-1">Richard Farkas</span>•<span class="pl-1">1 day
                ago</span></p>
              </div>
            </a>
          </li>
          <li>
            <a class="dropdown-item text-info" href="#">
              <i class="fa-solid fa-circle-info"></i>
              <div>
                <p class="notification-title text-wrap">Meditation</p>
                <p class="notification-subtitle"><span class="pr-1">Richard Farkas</span>•<span class="pl-1">1 day
              ago</span></p>
            </div>
          </a>
        </li>
        <li>
          <a class="dropdown-item text-info" href="#">
            <i class="fa-solid fa-circle-info"></i>
            <div>
              <p class="notification-title text-wrap">Meditation</p>
              <p class="notification-subtitle"><span class="pr-1">Richard Farkas</span>•<span class="pl-1">1 day
            ago</span></p>
          </div>
        </a>
      </li>
    </ul>
  </li> -->

}

@if (!user()) {
  <li class="nav-item">
    <button class="nav-link btn btn-link text-decoration-none" id="navbarLogging" role="button"
      [routerLink]="['/login']" routerLinkActive="active" [disabled]="loading()">
      <i class="fa-solid fa-right-from-bracket"></i><span class="nav-link-mobile pl-2">{{
    t('common.log_in')}}</span>
  </button>
</li>
}
</ul>
</div>

@if (user()) {
  <button class="sidebar-toggle btn-primary-light" (click)="toggleSidenavMode()">
    @if (sidenavMode() === 'wide') {
      <span><i class="fa-solid fa-angle-right"></i></span>
    }
    @if (sidenavMode() !== 'wide') {
      <span><i class="fa-solid fa-angle-left"></i></span>
    }
  </button>
}

</div>
</nav>